// extracted by mini-css-extract-plugin
export default {"remark":"fastRemark_remark__ML4Yh","box":"fastRemark_box__xa+Hk","title":"fastRemark_title__FXjeT","menu":"fastRemark_menu__RRJ6S","select":"fastRemark_select__8SowQ"};